<template>
    <div class="container">
      <EditDetailDialog
        :visible.sync="editDialogVisible"
        :is-edit="isDetailEdit"
        :editRow="editRow"
        :editIndex="editIndex"
        :productsList="productsList"
        :processTypes="processTypes"
        :incoOrderNo="form.incoOrderNo"
        @add="addSuccess"
        @update="updateSuccess"
      />
      <div style="position: relative; width: 100%">
        <div style="display: flex; flex-direction: row; align-items: center; width: 100%; justify-content: space-between">
          <h4 class="title" style="flex: 8;">{{isEdit ? $t('incomingOrder.orderDetail') : $t('incomingOrder.newOrders')}}</h4>
          <div style="flex: 2;">
            <input style="display: none;" ref="uploadFile" type="file" @change="importXlsx" accept=".xlsx, .xlc, .xlm, .xls, .xlt, .xlw">
            </input>
            <el-button v-if="!isEdit" size="mini" class="orange-button" @click="importStorage">
              {{$t('common.import')}}
            </el-button>
            <el-button v-if="isEdit" :loading="loading" :disabled="disableDelete" type="danger" size="mini" @click="deleteOrder">
              {{$t('common.delete')}}
            </el-button>
          </div>
        </div>
        <div class="separator"></div>
      </div>
      <div class="info-container">
        <el-form size="small" :model="form" style="width: 87%;" ref="refForm" :rules="rules" label-width="180px">
          <el-form-item label-width="0" style="margin-bottom: 0;">
            <h4 style="color: #169BD5;">{{$t('incomingOrder.essentialInformation')}}</h4>
          </el-form-item>
          <el-form-item label-width="0">
            <el-col :span="12">
              <el-form-item :label="$t('common.customerName') + ':'" prop="customerId">
                <el-select
                  v-model="form.customerId"
                  clearable
                  filterable
                  style="width: 100%;"
                  size="small"
                  @change="changeCustomer">
                  <el-option
                    v-for="item in customersList"
                    :key="item.id"
                    :label="item.customerName"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('common.orderNo') + ':'" prop="incoOrderNo">
                <el-input
                  :disabled="isEdit"
                  v-model.trim="form.incoOrderNo"
                  name="incoOrderNo"
                  type="text"
                  autocomplete="on"
                  clearable
                  size="small"
                  maxlength="50"
                />
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label-width="0">
            <el-col :span="12">
              <el-form-item :label="$t('common.contact') + ':'" prop="contact">
                <el-input
                  v-model.trim="form.contact"
                  name="contact"
                  type="text"
                  autocomplete="on"
                  clearable
                  size="small"
                  maxlength="16">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('common.contactPhone') + ':'" prop="contactPhone">
                <el-input
                  v-model.trim="form.contactPhone"
                  name="contactPhone"
                  type="tel"
                  autocomplete="on"
                  clearable
                  size="small">
                </el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label-width="0">
            <el-col :span="12">
              <el-form-item :label="$t('common.orderDate') + ':'" prop="orderDate">
                <el-date-picker
                  v-model="form.orderDate"
                  type="date"
                  size="small"
                  style="width: 100%;">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('common.priorityLevel') + ':'" prop="priorityLevel">
                <el-radio-group v-model="form.priorityLevel">
                  <el-radio v-for="(item, key) in priorityLevels" :label="item.val" :key="key">
                    {{item.explain}}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label-width="0">
            <el-col :span="12">
              <el-form-item :label="$t('incomingOrder.expectIncomingDate') + ':'" prop="expectincoDate">
                <el-date-picker
                  v-model="form.expectincoDate"
                  type="date"
                  size="small"
                  :picker-options="pickerOptions"
                  style="width: 100%;">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('incomingOrder.expectFinishDate') + ':'" prop="expectFinishDate">
                <el-date-picker
                  v-model="form.expectFinishDate"
                  type="date"
                  size="small"
                  :picker-options="pickerOptions"
                  style="width: 100%;">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label-width="0">
            <el-col :span="12">
              <el-form-item :label="$t('incomingOrder.attachment') + ':'" prop="attachment">
                <el-upload
                  :headers="headers"
                  :action="action"
                  :on-success="handleSuccess"
                  :on-remove="handleRemove"
                  :before-upload="handleBeforeUpload"
                  :on-error="handleError"
                  :on-preview="handlerPreview"
                  :on-exceed="handlerExceed"
                  :limit="1"
                  :file-list="fileList"
                  accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP,.PDF">
                  <el-button size="small" type="plain">{{$t('incomingOrder.upload')}}</el-button>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label-width="0">
            <el-col :span="24">
              <el-form-item :label="$t('common.comment') + ':'">
                <el-input
                  v-model="form.comment"
                  name="comment"
                  type="textarea"
                  autocomplete="on"
                  clearable
                  size="small"
                  maxlength="200"
                  :rows="3"
                  show-word-limit>
                </el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item v-if="isEdit" label-width="0" class="bottom-container">
            <el-button :loading="loading" size="small" type="primary" @click="submitForm">{{$t('common.update')}}</el-button>
          </el-form-item>
          <el-form-item label-width="0" style="margin-bottom: 0;">
            <h4 style="color: #169BD5;">{{$t('incomingOrder.orderDetails')}}</h4>
          </el-form-item>
          <el-row>
            <el-col :span="24">
              <el-table
                ref="table"
                stripe border
                size="mini"
                :data="form.productDetails"
                :cell-style="{textAlign: 'center', padding: '3px 0', fontSize: '12px'}"
                :header-cell-style="{textAlign: 'center', padding: '5px 0', fontSize: '12px', color: '#303133'}">
                <el-table-column width="50">
                  <template slot-scope="scope">
                    {{scope.$index + 1}}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('common.subNo')" v-if="isEdit">
                  <template slot-scope="scope">
                    <OrderBarCode :text="scope.row.subNo"/>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('common.productName')"
                  width="200">
                  <template slot-scope="scope">
                    <span v-if="isEdit">{{productsListObj[scope.row.productId]}}</span>
                    <el-form-item
                      v-else
                      label-width="0"
                      :prop="'productDetails.' + scope.$index + '.productId'"
                      :rules="{
                        required: true,
                        trigger: 'blur',
                        validator: (rule, value, callback) => checkProductId(rule, value, callback, scope.$index),
                      }">
                      <el-select
                        v-model="scope.row.productId"
                        clearable
                        filterable
                        style="width: 100%;"
                        :disabled="isEdit"
                        size="small">
                        <el-option
                          v-for="item in productsList"
                          :key="item.id"
                          :label="item.productName + ' / ' + item.chipName"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('common.isMixed')"
                  width="140">
                  <template slot-scope="scope">
                    <span v-if="isEdit">{{scope.row.isMixed ? '是' : '否'}}</span>
                    <el-form-item
                      v-else
                      label-width="0"
                      :prop="'productDetails.' + scope.$index + '.isMixed'"
                      :rules="{
                        required: true,
                        trigger: 'blur',
                        validator: (rule, value, callback) => checkIsMixed(rule, value, callback, scope.$index),
                      }">
                      <el-radio-group :disabled="isEdit" v-model="scope.row.isMixed">
                        <el-radio :label="true">
                          {{$t('common.yes')}}
                        </el-radio>
                        <el-radio :label="false">
                          {{$t('common.no')}}
                        </el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('common.processType')">
                  <template slot-scope="scope">
                    <span v-if="isEdit">{{processTypesObj[scope.row.processType]}}</span>
                    <el-form-item
                      v-else
                      label-width="0"
                      :prop="'productDetails.' + scope.$index + '.processType'"
                      :rules="{
                        required: true,
                        trigger: 'blur',
                        validator: (rule, value, callback) => checkProcessType(rule, value, callback, scope.$index),
                      }">
                      <el-select
                        v-model="scope.row.processType"
                        :disabled="isEdit"
                        filterable
                        style="width: 100%;"
                        size="small">
                        <el-option
                          v-for="(item, key) in processTypes"
                          :key="key"
                          :label="item.explain"
                          :value="item.val">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('common.lotNo')">
                  <template slot-scope="scope">
                    <span v-if="isEdit">{{scope.row.lotNo}}</span>
                    <el-form-item
                      v-else
                      label-width="0"
                      :prop="'productDetails.' + scope.$index + '.lotNo'"
                      :rules="{
                        required: true,
                        trigger: 'blur',
                        validator: (rule, value, callback) => checkLotNo(rule, value, callback, scope.$index),
                      }">
                      <el-input
                        v-model.trim="scope.row.lotNo"
                        :disabled="isEdit"
                        name="lotNo"
                        type="text"
                        autocomplete="on"
                        clearable
                        maxlength="32"
                        size="small"
                      />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="count"
                  :label="$t('common.count')">
                  <template slot-scope="scope">
                    <span v-if="isEdit">{{scope.row.count}}</span>
                    <el-form-item
                      v-else
                      label-width="0"
                      :prop="'productDetails.' + scope.$index + '.count'"
                      :rules="{
                        required: true,
                        trigger: 'blur',
                        validator: (rule, value, callback) => checkCount(rule, value, callback, scope.$index),
                      }">
                      <el-input
                        v-model.trim.number="scope.row.count"
                        :disabled="isEdit"
                        name="count"
                        type="tel"
                        autocomplete="on"
                        clearable
                        maxlength="10"
                        size="small"
                      />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('common.partNo')">
                  <template slot-scope="scope">
                    <span v-if="isEdit">{{scope.row.partNo}}</span>
                    <el-form-item
                      v-else
                      label-width="0"
                      :prop="'productDetails.' + scope.$index + '.partNo'"
                      :rules="{
                        required: true,
                        trigger: 'blur',
                        validator: (rule, value, callback) => checkPartNo(rule, value, callback, scope.$index),
                      }">
                      <el-input
                        v-model.trim="scope.row.partNo"
                        :disabled="isEdit"
                        name="partNo"
                        type="text"
                        autocomplete="on"
                        clearable
                        size="small"
                        maxlength="64">
                      </el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('common.endDevicen')">
                  <template slot-scope="scope">
                    <span v-if="isEdit">{{scope.row.endDevicen}}</span>
                    <el-form-item
                      label-width="0"
                      v-else
                      :prop="'productDetails.' + scope.$index + '.endDevicen'"
                      :rules="{
                        required: true,
                        trigger: 'blur',
                        validator: (rule, value, callback) => checkEndDevicen(rule, value, callback, scope.$index),
                      }">
                      <el-input
                        v-model.trim="scope.row.endDevicen"
                        :disabled="isEdit"
                        name="endDevicen"
                        type="text"
                        autocomplete="on"
                        clearable
                        size="small"
                        maxlength="64">
                      </el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column v-if="isEdit"  width="80" :label="$t('common.status')">
                  <template slot-scope="scope">
                    {{storeStatusVal(scope.row.status)}}
                  </template>
                </el-table-column>
                <el-table-column width="150" :label="$t('common.operate')">
                  <template slot-scope="scope">
                    <div v-if="isEdit && scope.row.status !== storeStatus.finished.val">
                      <el-button
                        type="text"
                        class="link"
                        :disabled="disableEditProduct(scope.row)"
                        @click="editDetail(scope.row, scope.$index)"
                        :class="{'is-disabled': disableEditProduct(scope.row)}">
                        {{$t('common.edit')}}
                      </el-button>
                      <span class="vertical-separator"></span>
                      <el-button
                        type="text"
                        class="link"
                        :disabled="disableDeleteProduct(scope.row)"
                        @click="deleteDetail(scope.$index, scope.row)"
                        :class="{'is-disabled': disableDeleteProduct(scope.row)}">
                        {{$t('common.delete')}}
                      </el-button>
                    </div>
                    <el-button
                      v-if="!isEdit"
                      type="text"
                      icon="el-icon-delete"
                      @click="deleteProductDetails(scope.$index, scope.row)">
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
          <el-form-item label-width="0" style="margin: 10px 0">
            <el-button
              class="orange-button"
              icon="el-icon-plus"
              @click="addClick"
              circle>
            </el-button>
          </el-form-item>>
          <el-form-item v-if="!isEdit" label-width="0" class="bottom-container">
            <el-button :loading="loading" size="small" type="primary" @click="submitForm">{{$t('common.save')}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import {
  incoOrderPost,
  incoOrderPut,
  incoOrderDetailById,
  delOrderProductDetail,
  incoOrderDelete,
} from '@/api/incoOrder';
import { customersList } from '@/api/customers';
import { productsList } from '@/api/products';
import {
  validateIncomingOrderNo,
  validateLotNo,
  validateCount,
  validateContactPhone,
  validateProductDetails,
} from '@/utils/validate';
import { processTypes, priorityLevels, storeStatus } from '@/utils/defines';
import { isValueEmpty, isPositiveIntegerNum } from '@/utils';
import EditDetailDialog from './components/EditDetailDialog';
import OrderBarCode from './components/OrderBarCode';
import { readXlsx } from '@/utils/fileRead';

const defaultProductDetail = {
  subNo: undefined,
  productId: undefined,
  lotNo: undefined,
  count: undefined,
  isMixed: false,
  processType: processTypes.FT.val,
  partNo: undefined,
  endDevicen: undefined,
};

const defaultForm = {
  customerId: undefined,
  incoOrderNo: undefined,
  priorityLevel: priorityLevels.low.val,
  orderDate: new Date(moment().startOf('day').valueOf()),
  expectincoDate: new Date(moment().startOf('day').add(3, 'days').valueOf()),
  contact: undefined,
  contactPhone: undefined,
  expectFinishDate: new Date(moment().startOf('day').add(7, 'days').valueOf()),
  attachment: undefined,
  comment: undefined,
  productDetails: [{
    ...defaultProductDetail,
  }],
};

export default {
  name: 'OrderDetail',
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    EditDetailDialog,
    OrderBarCode,
  },
  data() {
    const storeStatusObj = {};
    let storeStatueItem;
    for (const key in storeStatus) {
      if (Object.prototype.hasOwnProperty.call(storeStatus, key)) {
        storeStatueItem = storeStatus[key];
        storeStatusObj[storeStatueItem.val] = storeStatueItem.explain;
      }
    }
    const processTypesObj = {};
    let processTypeItem;
    for (const key in processTypes) {
      if (Object.prototype.hasOwnProperty.call(processTypes, key)) {
        processTypeItem = processTypes[key];
        processTypesObj[processTypeItem.val] = processTypeItem.explain;
      }
    }
    const validateOrderDate = (rule, value, callback) => {
      if (isValueEmpty(value) || value === null) {
        callback(new Error(this.$t('validate.expectIncomingDateCanNotBeEmpty')));
        return false;
      }
      const expectincoDate = this.form.expectincoDate;
      if (isValueEmpty(expectincoDate)) {
        callback();
        return true;
      }
      if (moment(value).isAfter(moment(expectincoDate))) {
        callback(new Error(this.$t('incomingOrder.orderDateCanNotBeLaterThanExpectedArrivalDate')));
        return false;
      }
      callback();
      return true;
    };
    const validateExpectincoDate = (rule, value, callback) => {
      if (isValueEmpty(value) || value === null) {
        callback(new Error(this.$t('validate.expectIncomingDateCanNotBeEmpty')));
        return false;
      }
      const orderDate = this.form.orderDate;
      if (isValueEmpty(orderDate)) {
        callback();
        return true;
      }
      if (moment(value).isBefore(moment(orderDate))) {
        callback(new Error(this.$t('incomingOrder.expectedArrivalDateCanNotBeEarlierThanOrderDate')));
        return false;
      }
      callback();
      return true;
    };
    const validateExpectFinishDate = (rule, value, callback) => {
      if (isValueEmpty(value) || value === null) {
        callback(new Error(this.$t('validate.expectFinishDateCanNotBeEmpty')));
        return false;
      }
      const expectincoDate = this.form.expectincoDate;
      if (isValueEmpty(expectincoDate)) {
        callback();
        return true;
      }
      if (moment(value).isBefore(moment(expectincoDate))) {
        callback(new Error(this.$t('incomingOrder.expectedCompletionDateCanNotBeEarlierThanOrderDate')));
        return false;
      }
      callback();
      return true;
    };
    return {
      form: {...defaultForm, productDetails : [{ ...defaultProductDetail }]},
      rules: {
        customerId: [{ required: true, trigger: 'blur', message: this.$t('validate.customerNameCanNotBeEmpty') }],
        incoOrderNo: [{ required: true, trigger: 'blur', validator: validateIncomingOrderNo }],
        priorityLevel: [{ required: true, trigger: 'blur', message: this.$t('validate.priorityLevelCanNotBeEmpty') }],
        orderDate: [{ required: true, trigger: 'blur', validator: validateOrderDate }],
        expectincoDate: [{ required: true, trigger: 'blur', validator: validateExpectincoDate }],
        contact: [{ required: true, trigger: 'blur', message: this.$t('validate.contactCanNotBeEmpty') }],
        contactPhone: [{ required: true, trigger: 'blur', validator: validateContactPhone }],
        expectFinishDate: [{ required: true, trigger: 'blur', validator: validateExpectFinishDate }],
      },
      customersList: [],
      productsList: [],
      productsListObj: {},
      processTypes,
      processTypesObj,
      priorityLevels,
      loading: false,
      fileList: [],
      tempRoute: {},
      storeStatus,
      storeStatusObj,
      editDialogVisible: false,
      editRow: {},
      editIndex: -1,
      isDetailEdit: false,
      status: undefined,
    };
  },
  mounted() {
    if (this.isEdit) {
      const orderNo = this.$route.params && this.$route.params.orderNo;
      this.incoOrderDetailById(orderNo);
    } else {
      this.form = {...defaultForm, productDetails : [{ ...defaultProductDetail }]};
    }
    this.customersListGet(1, 200);
    this.productsListGet(1, 200);
    this.tempRoute = Object.assign({}, this.$route);
  },
  computed: {
    ...mapGetters([
      'token',
    ]),
    pickerOptions() {
      const nowTime = moment().startOf('day').valueOf();
      return {
        disabledDate(time) {
          return time.getTime() < nowTime;
        },
      };
    },
    headers() {
      return {
        Authorization: `Bearer ${this.token}`,
      };
    },
    action() {
      return '/api/v1/files/incoming';
    },
    disableDelete() {
      return this.status !== storeStatus.noReceipt.val;
    }
  },
  methods: {
    async incoOrderDetailById(orderNo) {
      try {
        const res = await incoOrderDetailById({ incoOrderNo: orderNo });
        const { data } = res;
        const order = data.order || {};
        const {
          customerId,
          incoOrderNo,
          priorityLevel,
          orderDate,
          expectincoDate,
          contact,
          contactPhone,
          expectFinishDate,
          attachment,
          comment,
          incoOrdersDetails,
          status,
        } = order;
        let productDetails = [];
        if (!incoOrdersDetails || incoOrdersDetails && incoOrdersDetails.length === 0) {
          productDetails = [];
        } else {
          productDetails = incoOrdersDetails.map(item => {
            item.isMixed = item.isMixed === 1;
            return item;
          });
        }
        this.form = {
          customerId,
          incoOrderNo,
          priorityLevel,
          orderDate,
          expectincoDate,
          contact,
          contactPhone,
          expectFinishDate,
          attachment,
          comment,
          productDetails,
        };
        this.status = status;
        if (attachment) {
          this.fileList = [{
            name: attachment,
            url: this.attachmentUrl(attachment),
          }];
        }
      } catch (e) {
        this.form.incoOrderNo = orderNo;
        // do nothing.
      }
    },
    async customersListGet(page, perpage, customerName) {
      try {
        const res = await customersList({ page, perpage, customerName });
        const { data } = res;
        this.customersList = data.records;
      } catch (e) {
        // do nothing.
      }
    },
    async productsListGet(page, perpage) {
      try {
        const res = await productsList({ page, perpage });
        const { data } = res;
        this.productsList = data.records;
        this.productsListObj = {};
        for (let row of this.productsList) {
          this.productsListObj[row.id] = row.productName + ' / ' + row.chipName
        }
      } catch (e) {
        // do nothing.
      }
    },
    importStorage() {
      if (this.$refs.uploadFile && typeof this.$refs.uploadFile.dispatchEvent === 'function') {
        this.$refs.uploadFile.dispatchEvent(new MouseEvent('click'));
      }
    },
    importXlsx(e) {
      const file = e.currentTarget.files[0];
      this.$refs.uploadFile.value = null;
      const nameSuffix = file.name.split('.').reverse()[0];
      if (!(['xlsx', 'xlc', 'xlm', 'xls', 'xlt', 'xlw'].includes(nameSuffix))) {
        this.$message({
          message: this.$t('incomeStorage.importedFileFormatIncorrect'),
          type: 'error',
        });
        return;
      }
      const isCSV = nameSuffix === 'csv';
      if (isCSV) {
        // csv2arr(file, (res) => {
        //   this.csvDataDisplay(res);
        // })
      } else {
        readXlsx(file, (res) => {
          let isNewOrderXlsx = false;
          for (let row of res) {
            if (row['公司名称'] !== undefined && row['订单号'] !== undefined) {
              isNewOrderXlsx = true;
              break;
            }
          }
          if (isNewOrderXlsx) {
            this.newXlsxDataDisplay(res);
          } else {
            this.xlsxDataDisplay(res);
          }
        });
      }
    },
    newXlsxDataDisplay(xlsxData) {
      const {
        customersList,
        priorityLevels,
        processTypes,
        productsList
      } = this;
      const customersListObj = {};
      const priorityLevelsObj = {};
      const productsListObj = {};
      for (let row of customersList) {
        customersListObj[row.customerName] = { ...row };
      }
      for (let v of Object.values(priorityLevels)) {
        priorityLevelsObj[v.explain] = v.val;
      }
      for (let row of productsList) {
        productsListObj[row.productName+ '/' + row.chipName] = row.id;
      }
      let incoOrderNo, incoOrderNoVal, customerId, customerVal, customerObj, priorityLevelVal, orderDate, priorityLevel;
      let contact, contactPhone, productDetailsObj = {}, productDetailsObjKey, productDetailsObjVal, processType, productId;
      let count;
      console.warn(xlsxData);
      for (let row of xlsxData) {
        incoOrderNoVal = row['订单号'];
        if (incoOrderNo === undefined) {
          incoOrderNo = incoOrderNoVal;
        } else if (incoOrderNo !== incoOrderNoVal) {
          this.$message({
            message: this.$t('incomingOrder.manyTypesOfOutsourcedOrderNumberInImportedData'),
            type: 'error',
          });
          return;
        }
        if (customerId === undefined) {
          customerVal = row['公司名称'];
          customerObj = customersListObj[customerVal];
          if (customerObj) {
            customerId = customerObj.id;
            contact = customerObj.contact;
            contactPhone = customerObj.contactPhone;
          }
        }
        if (priorityLevelVal === undefined) {
          priorityLevelVal = row['紧急度'];
          priorityLevel = priorityLevelsObj[priorityLevelVal] || priorityLevels.low.val;
        }
        if (orderDate === undefined) {
          orderDate = row['订单制作时间'] ? new Date(moment(this.formatDate(row['订单制作时间']), 'YYYYMMDD').valueOf()) : undefined;
        }
        processType = processTypes[row['终止制程']] && processTypes[row['终止制程']].val || processTypes.FT.val;
        console.warn(row['压焊图内成品名称'] + '/' + row['芯片名称'], productsListObj);
        productId = productsListObj[row['压焊图内成品名称'] + '/' + row['芯片名称']];
        productDetailsObjKey = row['压焊图内成品名称'] + '/' + row['芯片名称'] + '/'
          + row['加工的封装形式'] + '/' + row['订单号'] + '/'
          + row['印章批号'] + '/' + processType;
        productDetailsObjVal = productDetailsObj[productDetailsObjKey];
        count = isPositiveIntegerNum(row['颗数']) ? row['颗数'] : 0;
        if (productDetailsObjVal) {
          productDetailsObj[productDetailsObjKey].count = count + productDetailsObjVal.count;
        } else {
          productDetailsObj[productDetailsObjKey] = {
            productId: productId,
            lotNo: row['印章批号'],
            count: count,
            isMixed: false,
            processType: processType,
            partNo: row['标签上打印的PARTNO'],
            endDevicen: row['加工完成品名称'],
          };
        }
      }
      this.form.incoOrderNo = incoOrderNo;
      this.form.customerId = customerId;
      this.form.priorityLevel = priorityLevel;
      this.form.orderDate = orderDate || new Date(moment().startOf('day').valueOf());
      this.form.contact = contact;
      this.form.contactPhone = contactPhone;
      this.form.productDetails = Object.values(productDetailsObj);
    },
    xlsxDataDisplay(xlsxData) {
      const {
        customersList,
        priorityLevels,
        processTypes,
        productsList
      } = this;
      const customersListObj = {};
      const priorityLevelsObj = {};
      const productsListObj = {};
      for (let row of customersList) {
        customersListObj[row.customerName] = { ...row };
      }
      for (let v of Object.values(priorityLevels)) {
        priorityLevelsObj[v.explain] = v.val;
      }
      for (let row of productsList) {
        productsListObj[row.productName+ '/' + row.chipName] = row.id;
      }
      let incoOrderNo, incoOrderNoVal, customerId, customerVal, customerObj, priorityLevelVal, orderDate, priorityLevel;
      let contact, contactPhone, productDetailsObj = {}, productDetailsObjKey, productDetailsObjVal, processType, productId;
      let count;
      for (let row of xlsxData) {
        incoOrderNoVal = row['外包单号'];
        if (incoOrderNo === undefined) {
          incoOrderNo = incoOrderNoVal;
        } else if (incoOrderNo !== incoOrderNoVal) {
          this.$message({
            message: this.$t('incomingOrder.manyTypesOfOutsourcedOrderNumberInImportedData'),
            type: 'error',
          });
          return;
        }
        if (customerId === undefined) {
          customerVal = row['单位'];
          customerObj = customersListObj[customerVal];
          if (customerObj) {
            customerId = customerObj.id;
            contact = customerObj.contact;
            contactPhone = customerObj.contactPhone;
          }
        }
        if (priorityLevelVal === undefined) {
          priorityLevelVal = row['紧急度'];
          priorityLevel = priorityLevelsObj[priorityLevelVal] || priorityLevels.low.val;
        }
        if (orderDate === undefined) {
          orderDate = row['外包日期'] ? new Date(moment(this.formatDate(row['外包日期']), 'YYYYMMDD').valueOf()) : undefined;
        }
        processType = processTypes[row['终止制程']] && processTypes[row['终止制程']].val || processTypes.FT.val;
        productId = productsListObj[row['压焊图内成品名称'] + '/' + row['芯片名称']];
        productDetailsObjKey = row['压焊图内成品名称'] + '/' + row['芯片名称'] + '/'
          + row['加工项目'] + '/' + row['外包单号'] + '/'
          + row['印章批号'] + '/' + processType;
        productDetailsObjVal = productDetailsObj[productDetailsObjKey];
        count = isPositiveIntegerNum(row['送封颗数']) ? row['送封颗数'] : 0;
        if (productDetailsObjVal) {
          productDetailsObj[productDetailsObjKey].count = count + productDetailsObjVal.count;
        } else {
          productDetailsObj[productDetailsObjKey] = {
            productId: productId,
            lotNo: row['印章批号'],
            count: count,
            isMixed: false,
            processType: processType,
            partNo: row['标签上打印的PARTNO'],
            endDevicen: row['加工完成品名称'],
          };
        }
      }
      this.form.incoOrderNo = incoOrderNo;
      this.form.customerId = customerId;
      this.form.priorityLevel = priorityLevel;
      this.form.orderDate = orderDate || new Date(moment().startOf('day').valueOf());
      this.form.contact = contact;
      this.form.contactPhone = contactPhone;
      this.form.productDetails = Object.values(productDetailsObj);
    },
    formatDate(numb, format) {
      const time = new Date((numb - 1) * 24 * 3600000 + 1)
      time.setYear(time.getFullYear() - 70)
      const year = time.getFullYear() + ''
      const month = time.getMonth() + 1 + ''
      const date = time.getDate() + ''
      if (format && format.length === 1) {
        return year + format + month + format + date
      }
      return year + (month < 10 ? '0' + month : month) + (date < 10 ? '0' + date : date)
    },
    deleteOrder() {
      this.$confirm(this.$t('incomingOrder.thisActionWillDeleteThisOrder'), this.$t('remindInfo.warning'), {
        confirmButtonText: this.$t('remindInfo.confirm'),
        cancelButtonText: this.$t('remindInfo.cancel'),
        type: 'warning',
      }).then(async () => {
        const {
          incoOrderNo
        } = this.form;
        this.loading = true;
        try {
          await incoOrderDelete({
            incoOrderNo,
          });
          this.$message({
            type: 'success',
            message: this.$t('common.deleteSuccess'),
          });
          this.backOrderListPage();
        } catch (e) {
        } finally {
          this.loading = false;
        }
      }).catch(() => {
        // do nothing.
      });
    },
    changeCustomer(val) {
      if (val) {
        for (const row of this.customersList) {
          if (row.id === val) {
            this.form.contact = row.contact;
            this.form.contactPhone = row.contactPhone;
            this.$refs.refForm.validateField(['customerId', 'contact', 'contactPhone']);
            break;
          }
        }
      }
    },
    changeProcessType(val) {
      for (const key in processTypes) {
        if (Object.prototype.hasOwnProperty.call(processTypes, key)) {
          if (processTypes[key].val === val) {
            this.form.startDevicen = processTypes[key].startDevicen;
            this.form.endDevicen = processTypes[key].endDevicen;
            break;
          }
        }
      }
    },
    handleSuccess(response, file) {
      this.form.attachment = file.name;
      this.$message({
        type: 'success',
        message: this.$t('common.uploadSuccess'),
      });
    },
    handleError() {
      this.$message({
        type: 'error',
        message: this.$t('common.uploadFailure'),
      });
    },
    handleRemove() {
      this.form.attachment = undefined;
    },
    handlerPreview(file) {
      const url = this.attachmentUrl(file.name);
      window.open(url, 'blank');
    },
    handlerExceed() {
      this.$message({
        type: 'error',
        message: this.$t('incomingOrder.anOrderCanOnlyHaveAtMostOneAttachment'),
      });
    },
    attachmentUrl(attachment) {
      return `${window.location.protocol}//${window.location.hostname}:${window.location.port}/incoming/${attachment}`;
    },
    handleBeforeUpload(file) {
      const isLessThan2M = file.size / 1024 / 1024 < 2;
      if (!isLessThan2M) {
        this.$message({
          type: 'error',
          message: this.$t('common.sizeNotExceed2M'),
        });
      }
      return isLessThan2M;
    },
    reset() {
      this.form = Object.assign({}, defaultForm);
      if (this.$refs.refForm && typeof this.$refs.refForm.resetFields === 'function') {
        this.$refs.refForm.resetFields();
      }
    },
    editDetail(row, index) {
      this.editRow = row;
      this.editIndex = index;
      this.isDetailEdit = true;
      this.editDialogVisible = true;
    },
    addDetail() {
      const {
        incoOrderNo,
        productDetails,
      } = this.form;
      if (productDetails && productDetails.length > 0) {
        const lastSubNo = productDetails[0].subNo;
        if (lastSubNo) {
          const splitSubNoArray = lastSubNo.split('#');
          const maxNo = Number.parseInt(splitSubNoArray[splitSubNoArray.length - 1], 10);
          this.editRow = {
            ...defaultProductDetail,
            subNo: `${incoOrderNo}#${maxNo + 1}`,
          };
        } else {
          this.editRow = {
            ...defaultProductDetail,
            subNo: `${incoOrderNo}#0`,
          };
        }
      } else {
        this.editRow = {
          ...defaultProductDetail,
          subNo: `${incoOrderNo}#0`,
        };
      }
      this.isDetailEdit = false;
      this.editDialogVisible = true;
    },
    deleteDetail(index, row) {
      this.$confirm(this.$t('incomingOrder.thisActionWillDeleteTheProductsInThisOrder'), this.$t('remindInfo.warning'), {
        confirmButtonText: this.$t('remindInfo.confirm'),
        cancelButtonText: this.$t('remindInfo.cancel'),
        type: 'warning',
      }).then(async () => {
        const {
          incoOrderNo
        } = this.form;
        const {
          productId,
          lotNo,
          processType,
        } = row;
        try {
          await delOrderProductDetail({
            incoOrderNo,
            productId,
            lotNo,
            processType,
          });
          this.$message({
            type: 'success',
            message: this.$t('incomeStorage.deleteSuccess'),
          });
          this.form.productDetails.splice(index, 1);
        } catch (e) {
          // do nothing.
        }
      }).catch(() => {
        // do nothing.
      });
    },
    submitForm() {
      this.$refs.refForm.validate(async (valid) => {
        if (valid) {
          if (!this.isEmptyProductDetails()) {
            return;
          }
          if (this.isEdit) {
            this.incoOrderPut();
          } else {
            this.incoOrderPost();
          }
        }
      });
    },
    isEmptyProductDetails() {
      const {
        productDetails,
      } = this.form;
      if (productDetails && productDetails.length === 0) {
        this.$message({
          type: 'error',
          message: this.$t('validate.productDetailsCanNotBeEmpty'),
        });
        return false;
      }
      let productId, lotNo, count, endDevicen, isMixed, processType, isDataEmpty, isEmptyProductDetails = true;
      for (let row of productDetails) {
        productId = row.productId;
        lotNo = row.lotNo;
        count = row.count;
        endDevicen= row.endDevicen;
        isMixed= row.isMixed;
        processType= row.processType;
        isDataEmpty = isValueEmpty(productId) && isValueEmpty(lotNo) && isValueEmpty(count) && isValueEmpty(endDevicen) && isMixed === false && processType === processTypes.FT.val
        if (!isDataEmpty) {
          isEmptyProductDetails = false;
           break;
        }
      }
      if (isEmptyProductDetails) {
        this.$message({
          type: 'error',
          message: this.$t('validate.productDetailsCanNotBeEmpty'),
        });
        return false;
      }
      return true;
    },
    async incoOrderPut() {
      this.loading = true;
      try {
        const {
          customerId,
          incoOrderNo,
          priorityLevel,
          orderDate,
          expectincoDate,
          contact,
          contactPhone,
          expectFinishDate,
          attachment,
          comment,
        } = this.form;
        await incoOrderPut({
          customerId,
          incoOrderNo,
          priorityLevel,
          orderDate,
          expectincoDate,
          contact,
          contactPhone,
          expectFinishDate,
          attachment: attachment || undefined,
          comment: comment || undefined,
        });
        this.$message({
          type: 'success',
          message: this.$t('common.updateSuccess'),
        });
        this.backOrderListPage();
      } catch (e) {
        // do nothing.
      } finally {
        this.loading = false;
      }
    },
    async incoOrderPost() {
      this.loading = true;
      try {
        const {
          incoOrderNo,
          attachment,
          comment,
          productDetails,
        } = this.form;
        let productId, lotNo, count, partNo, endDevicen, isDataEmpty, index = 0;
        const detail = [];
        productDetails.map(row => {
          productId = row.productId;
          lotNo = row.lotNo;
          count = row.count;
          partNo = row.partNo;
          endDevicen = row.endDevicen;
          isDataEmpty = isValueEmpty(productId) || isValueEmpty(lotNo) || isValueEmpty(count) || isValueEmpty(partNo) || isValueEmpty(endDevicen);
          if (!isDataEmpty) {
            index++;
            detail.push({
                ...row,
              subNo: `${incoOrderNo}#${index}`,
            })
          }
        });
        await incoOrderPost({
          ...this.form,
          attachment: attachment || undefined,
          comment: comment || undefined,
          productDetails: detail && detail.length > 0 ? detail : undefined,
        });
        this.$message({
          type: 'success',
          message: this.$t('common.createSuccess'),
        });
        this.backOrderListPage();
      } catch (e) {
        // do nothing.
      } finally {
        this.loading = false;
      }
    },
    storeStatusVal(val) {
      return this.storeStatusObj[`${val}`];
    },
    backOrderListPage() {
      this.$router.replace({ path: '/redirect/incoming-order/list' });
      this.$store.dispatch('tagsView/delView', this.tempRoute);
    },
    addClick() {
     if (this.isEdit) {
       this.addDetail();
     } else {
       this.addProductDetails();
     }
    },
    addProductDetails() {
      this.form.productDetails.push({...defaultProductDetail});
    },
    deleteProductDetails(index) {
      this.form.productDetails.splice(index, 1);
    },
    addSuccess(itemData) {
      this.form.productDetails.unshift(itemData);
    },
    updateSuccess(itemData, index) {
      this.form.productDetails.splice(index, 1, itemData);
    },
    isAllDataEmpty(index) {
      const {
        productId,
        lotNo,
        count,
        isMixed,
        processType,
        partNo,
        endDevicen,
      } = this.form.productDetails[index];
      return isValueEmpty(productId) && isValueEmpty(lotNo) && isValueEmpty(count) && isValueEmpty(partNo) && isValueEmpty(endDevicen) && isMixed === false && processType === processTypes.FT.val;
    },
    checkProductId(rule, value, callback, index) {
      if (this.isAllDataEmpty(index)) {
        callback();
        return true;
      }
      if (isValueEmpty(value)) {
        callback(new Error(this.$t('validate.productNameCanNotBeEmpty')));
        return false;
      }
      callback();
      return true;
    },
    checkIsMixed(rule, value, callback, index) {
      if (this.isAllDataEmpty(index)) {
        callback();
        return true;
      }
      if (isValueEmpty(value)) {
        callback(new Error(this.$t('validate.isMixedCanNotBeEmpty')));
        return false;
      }
      callback();
      return true;
    },
    checkProcessType(rule, value, callback, index) {
      if (this.isAllDataEmpty(index)) {
        callback();
        return true;
      }
      if (isValueEmpty(value)) {
        callback(new Error(this.$t('validate.processTypeCanNotBeEmpty')));
        return false;
      }
      callback();
      return true;
    },
    checkLotNo(rule, value, callback, index) {
      if (this.isAllDataEmpty(index)) {
        callback();
        return true;
      }
      return validateLotNo(rule, value, callback);
    },
    checkCount(rule, value, callback, index) {
      if (this.isAllDataEmpty(index)) {
        callback();
        return true;
      }
      return validateCount(rule, value, callback);
    },
    checkPartNo(rule, value, callback, index) {
      if (this.isAllDataEmpty(index)) {
        callback();
        return true;
      }
      if (isValueEmpty(value)) {
        callback(new Error(this.$t('validate.partNoCanNotBeEmpty')));
        return false;
      }
      callback();
      return true;
    },
    checkEndDevicen(rule, value, callback, index) {
      if (this.isAllDataEmpty(index)) {
        callback();
        return true;
      }
      if (isValueEmpty(value)) {
        callback(new Error(this.$t('validate.endDevicenCanNotBeEmpty')));
        return false;
      }
      callback();
      return true;
    },
    disableEditProduct(row) {
      return row.status === storeStatus.finished.val;
    },
    disableDeleteProduct(row) {
      return row.status !== storeStatus.noReceipt.val;
    },
  },
};
</script>

<style scoped>
  .container {
    height: 100%;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
    overflow: auto;
    width: 100%;
  }
  .separator {
    width: 100%;
    height: 1px;
    background: #E5E5E5;
    display: block;
  }
  .title {
    margin: 10px 20px;
    font-size: 16px;
    color: #555555;
  }
  .info-container {
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    justify-content: center;
  }
  .bottom-container {
    text-align: center;
    margin: 20px 0;
  }
  .link {
    color: #169BD5;
    padding: 0 5px;
  }
  .link.is-disabled {
    color: #C0C4CC;
  }
  .vertical-separator {
    display: inline-block;
    width: 1px;
    height: 12px;
    margin: 0 13px;
    vertical-align: middle;
    background: #e8e8e8;
  }
  .orange-button {
    background: #FF8605;
    color: white;
    border: 0;
  }
</style>
